export enum SectorInclination {
    OneToOne,
    OnePointFiveToOne,
    OnePointSeventFiveToOne,
    TwoToOne,
    ThreeToOne,
    TwoToThree,
    NinetyDegrees,
    GabionSixDegrees,
    Plain,
    ByAngle,
}

export enum SubSectorPosition {
    Right,
    Left,
    Center,
}

export enum ChannelType {
    LeftOverbank,
    MainChannel,
    RightOverbank,
}
